import { styled } from 'styled-components';
import { theme } from '../theme';

export interface ContainerProps {
  children: React.ReactNode;
  wide?: boolean;
}

const ThemeContainer: React.FC<ContainerProps & { className?: string }> = ({ children, className, wide }) => {
  return (
    <ContainerWrapper className={className} $maxWidth={wide ? 1200 : 720}>
      {children}
    </ContainerWrapper>
  );
};

const ContainerWrapper = styled.div<{ $orientation?: 'horizontal' | 'vertical'; $maxWidth?: number }>`
  flex: 1;
  padding-top: ${theme.spacing.xl};
  max-width: ${props => props.$maxWidth}px;
  margin: 0 auto;
  width: 100%;
`;

export default ThemeContainer;
